<template>
  <div>
    <hosting-services v-if="!$route.params.hostingid"/>
    <router-view v-else />
  </div>
</template>

<script>
import HostingServices from 'Components/Services/Hosting/ServicesPage/HostingServices'

export default {
  name: 'HostingServicesView',
  components: {
    HostingServices
  },
}
</script>
